import { reduce } from 'ramda';
import moment from 'moment-timezone';
import { FETCH_SIDE_BY_SIDE } from '../constants';

const workday = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SIDE_BY_SIDE:
      return reduce((acc, barber) => {
        if (!barber.workday.start) {
          return acc;
        }
        acc[barber.id] = {
          start: moment.tz(barber.workday.start, barber.workday.timezone).format('H:mm'),
          end: moment.tz(barber.workday.end, barber.workday.timezone).format('H:mm'),
        };
        return acc;
      }, {}, action.payload.barbers);
    default:
      return state;
  }
};

export default workday;
